import {
    INTRODUCTION_CREATE,
    INTRODUCTION_CREATE_SUCCESS,
    INTRODUCTION_CREATE_FAILURE,
    GET_INTRODUCTION,
    GET_INTRODUCTION_SUCCESS,
    GET_INTRODUCTION_FAILURE,
    PATCH_INTRODUCTION,
    PATCH_INTRODUCTION_SUCCESS,
    PATCH_INTRODUCTION_FAILURE,
    KANA_GET,
    KANA_GET_SUCCESS,
    KANA_GET_FAILURE
} from './mutation-types'

export default {
  state: {
  },
  getters: {
  },
  actions: {
    [INTRODUCTION_CREATE] ({ dispatch, commit }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiPost', { url: '/asovi/introductions', data: params.data })
          .then(res => {
            if (res.status === 200 || res.status === 304) {
              if (res.data.error) {
                commit(INTRODUCTION_CREATE_FAILURE)
                reject(res.data.error)
              } else {
                commit(INTRODUCTION_CREATE_SUCCESS)
                resolve(res.data)
              }
            }
          })
          .catch(err => {
            commit(INTRODUCTION_CREATE_FAILURE)
            reject(err)
          })
      })
    },
    [GET_INTRODUCTION] ({ dispatch, commit }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: '/asovi/introductions', data: params })
          .then(res => {
            if (res.status === 200 || res.status === 304) {
              if (res.data.error) {
                commit(GET_INTRODUCTION_FAILURE)
                reject(res.data.error)
              } else {
                commit(GET_INTRODUCTION_SUCCESS)
                resolve(res.data)
              }
            }
          })
          .catch(err => {
            commit(GET_INTRODUCTION_FAILURE)
            reject(err)
          })
      })
    },
    [PATCH_INTRODUCTION] ({ dispatch, commit }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiPatch', { url: '/asovi/introductions/send_request', data: params })
          .then(res => {
            if (res.status === 200 || res.status === 304) {
              if (res.data.error) {
                commit(PATCH_INTRODUCTION_FAILURE)
                reject(res.data.error)
              } else {
                commit(PATCH_INTRODUCTION_SUCCESS)
                resolve(res.data)
              }
            }
          })
          .catch(err => {
            commit(PATCH_INTRODUCTION_FAILURE)
            reject(err)
          })
      })
    },
    [KANA_GET] ({ dispatch, commit }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiGet', {url: '/asovi/introductions/kana_get', data: params.data})
          .then(res => {
            if (res.status === 200 || res.status === 304) {
              if (res.data.error) {
                commit(KANA_GET_FAILURE, res.data)
                reject(res.data.error)
              } else {
                commit(KANA_GET_SUCCESS, { data: res.data })
                resolve(res.data)
              }
            }
          })
          .catch(error => {
            throw error
          })
      })
    }
  },
  mutations: {
    [INTRODUCTION_CREATE_FAILURE] () {
      console.log('INTRODUCTION_CREATE_FAILURE')
    },
    [INTRODUCTION_CREATE_SUCCESS] (state, data) {
      console.log('INTRODUCTION_CREATE_SUCCESS')
    },
    [GET_INTRODUCTION_FAILURE] () {
      console.log('GET_INTRODUCTION_FAILURE')
    },
    [GET_INTRODUCTION_SUCCESS] (state, data) {
      console.log('GET_INTRODUCTION_SUCCESS')
    },
    [PATCH_INTRODUCTION_FAILURE] () {
      console.log('PATCH_INTRODUCTION_FAILURE')
    },
    [PATCH_INTRODUCTION_SUCCESS] (state, data) {
      console.log('PATCH_INTRODUCTION_SUCCESS')
    },
    [KANA_GET_FAILURE] () {
      console.log('KANA_GET_FAILURE')
    },
    [KANA_GET_SUCCESS] (state, data) {
      console.log('KANA_GET_SUCCESS')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/introduction.js